<template>
  <div class = "container">
    <div class = "landing"></div>
    <div class = "overlay"></div>
    <Header color="white" type="page" />
    <main class = "text">
      <h1><span style="font-weight: 300; font-size: 2rem;">Welcome to the</span><br/>
      Mobile Coupon Tool</h1>
      <button @click = "submit()">Get Started</button>
    </main>
  </div>
</template>

<script>
import Header from '../components/Header'
export default {
  name: 'Landing',
  components: {
    Header
  },
  data () {
    return {
      lang: ''
    }
  },
  methods: {
    submit () {
      this.$router.push('/promotions')
    }
  }
}
</script>


<style scoped>
.landing {
  background: url('../assets/landing.jpg') no-repeat center center fixed;
  width: 100%;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -10;
  filter: blur(2px);
}

.overlay {
  width: 100%;
  height: 100%;
  background-color: #000;
  position: fixed;
  opacity: 0.75;
}

.container {
  width: 100%;
}

.text {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  min-height: stretch;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
}

h1 {
  font-size: 3rem;
  margin: 0;
  text-align: center;
}

@media (max-width: 440px) {
  h1 {
  font-size: 2.3rem;
  }
}

button {
  background-color: #229BD8;
  height: 3rem;
  font-size: 1.3rem;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: white;
  width: 10rem;
  border-radius: 0.3rem;
  margin: 3rem auto;
  border: none
}
</style>

